import { useCounter } from '@/hooks/useCounter'
import AnimatedSection from '@/components/AnimatedSection'

function StatItem({ value, suffix, label }: { value: number; suffix: string; label: string }) {
  const { count, ref } = useCounter(value, 2000)

  return (
    <div ref={ref} className="border-l border-neutral-800 pl-5">
      <div className="text-4xl font-semibold text-accent sm:text-5xl">
        {count}{suffix}
      </div>
      <div className="mt-2 text-xs uppercase tracking-[0.18em] text-neutral-400">{label}</div>
    </div>
  )
}

export default function StatsSection() {
  const stats = [
    { value: 15, suffix: '+', label: 'Years Experience' },
    { value: 500, suffix: '+', label: 'Projects Completed' },
    { value: 200, suffix: '+', label: 'Happy Clients' },
    { value: 99, suffix: '%', label: 'Accuracy Rate' },
  ]

  return (
    <section className="bg-black py-24">
      <div className="section-padding mx-auto max-w-7xl">
        <AnimatedSection className="mb-14 max-w-3xl">
          <span className="text-xs font-semibold uppercase tracking-[0.22em] text-accent">
            By The Numbers
          </span>
          <h2 className="mt-4 text-3xl font-semibold leading-tight text-white sm:text-4xl">
            Trusted by Industry Leaders
          </h2>
          <p className="mt-5 text-sm leading-7 text-neutral-400">
            Our track record speaks for itself. With over a decade of experience,
            we have consistently delivered exceptional results.
          </p>
        </AnimatedSection>

        <div className="grid grid-cols-2 gap-8 lg:grid-cols-4 lg:gap-12">
          {stats.map((stat) => (
            <AnimatedSection key={stat.label} delay={0.1}>
              <StatItem
                value={stat.value}
                suffix={stat.suffix}
                label={stat.label}
              />
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  )
}
